export const WHATSAPP_BUSINESS_VERTICALS = [
    "Automotive",
    "Beauty, Spa, and Salon",
    "Clothing and Apparel",
    "Education",
    "Entertainment",
    "Event Planning and Service",
    "Finance and Banking",
    "Food and Grocery",
    "Public Service",
    "Hotel and Lodging",
    "Medical and Health",
    "Non-profit",
    "Professional Services",
    "Shopping and Retail",
    "Travel and Transportation",
    "Restaurant",
    "Other",
];
